import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import React from 'react'
import { LicenseService } from '../../Component/Api/License/LicenseService';
import { MDTypography } from '../../Component/Common/Components/MDTypography';
import { CustomDialogTitle } from '../Common/Custom/CustomDialogTitle'

interface IProps {
  showInterestModal: boolean;
  handleClose: () => void;
}

export const EE123InterestModal = (props: IProps) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const expressInterest = async () => {
    setIsSubmitting(true);
    try {
      await LicenseService.ExpressEE123Interest();
      setShowSuccessMessage(true);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open={props.showInterestModal} onClose={props.handleClose} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth disableEnforceFocus>
      <CustomDialogTitle id="customized-dialog-title" onClose={props.handleClose}>
        {showSuccessMessage ? 'Email Sent' : 'You are not currently subscribed to the EE123 Module'}
      </CustomDialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={10}>
            <MDTypography variant="body2">
              {showSuccessMessage ? 'Thank you for your interest. An EE123 team member will be in touch with you soon.' : 'Want more information on how EE123 can revolutionize your Employment Equity compliance?'}
            </MDTypography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {showSuccessMessage ? (
          <Button color='primary' variant='contained' onClick={props.handleClose}>Done</Button>
        ) : (
          <LoadingButton variant='contained' color="primary" loading={isSubmitting} onClick={expressInterest}>
            Yes, Please
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  )
}
